//polyfill voor safari op ios <= 15 waar groupby niet bestaat

const hasNoGroup =
  typeof Object.groupBy === typeof undefined ||
  typeof Array.groupToMap === typeof undefined ||
  typeof Array.group === typeof undefined;
if (hasNoGroup) {
  const groupBy = (arr, callback) => {
    return arr.reduce((acc = {}, ...args) => {
      const key = callback(...args);
      acc[key] = acc[key] ?? [];
      acc[key].push(args[0]);
      return acc;
    }, {});
  };

  if (typeof Object.groupBy === typeof undefined) {
    Object.groupBy = groupBy;
  }

  if (typeof Array.groupToMap === typeof undefined) {
    Array.groupToMap = groupBy;
  }

  if (typeof Array.group === typeof undefined) {
    Array.group = groupBy;
  }
}
